import React from "react";
import PropTypes from "prop-types";
import styles from "./SettingsListItem.module.css";
import { ChevronRight } from "react-ikonate";

export function SettingsListItem({ icon, label, onClick }) {
  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.contentContainer}>
        <img src={icon} alt="Logo" className={styles.logo} />
        <div className={styles.textContainer}>
          <span>{label}</span>
        </div>
      </div>
      <ChevronRight className={styles.dropdownArrow} />
    </div>
  );
}

SettingsListItem.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
};
